export const dateFormats = ['MM/DD/YYYY', 'DD/MM/YYYY', 'YYYY/MM/DD']